export default __webpack_public_path__ + "static/media/resume-star.783b26be.svg";